import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ServiciodeperfildeusuarioService {

  admin = false;
  superadmin = false;
  admintarifas = false
  supervisor = false
  conciliador = false
  coordinador = false
  sena = false

  accesoProveedores = false
  accesoLogs = false
  accesoReportes = false
  accesoBusquedaTicket = false
  accesoPedidosActivos = false
  accesoPreconciliacion = false
  accesoConciliacion = false
  accesoAfes = false
  accesoVistoBueno = false
  accesoRegionales = false
  accesoUsuariosTarifas = false
  accesoEvaluacionProveedores = false
  accesoGraficaCeCo = false
  accesoEquipos = false
  accesoAlcancesTarifas = false
  accesoUsuarios = false
  accesoEdicion = false
  accesoEdicionFechas = false
  accesoDesPreconciliar = false
  accesoCambioStatus =false

  constructor() { }


  reset(){
   this.admin = false;
   this.superadmin = false;
   this.admintarifas = false
   this.supervisor = false
   this.conciliador = false
   this.coordinador = false
   this.sena = false

   this.accesoProveedores = false
   this.accesoLogs = false
   this.accesoReportes = false
   this.accesoBusquedaTicket = false
   this.accesoPedidosActivos = false
   this.accesoPreconciliacion = false
  this.accesoConciliacion = false
  this.accesoAfes = false
  this.accesoVistoBueno = false
  this.accesoRegionales = false
  this.accesoUsuariosTarifas = false
  this.accesoEvaluacionProveedores = false
  this. accesoGraficaCeCo = false
  this.accesoEquipos = false
  this.accesoAlcancesTarifas = false
  this.accesoUsuarios = false
  this.accesoEdicion = false
  this.accesoEdicionFechas = false
  this.accesoDesPreconciliar = false
  this.accesoCambioStatus =false
  }

}
